export default "__VITE_ASSET__D60nA0q2__"